import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
      },
      content: {
        fontFamily: 'Nunito',
        fontWeight: 300,
        fontSize: '16px',
        textAlign: 'justify',
        letterSpacing: '0.44px'
      }
    }),
  {
    name: 'AlertModal',
  }
);